import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@modules/auth/services/auth.service';

export const authenticationGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isAuthenticated = authService.getUser();

  if (isAuthenticated.id !== '0' && state.url === '/login') {
    // Si el usuario está autenticado y trata de ir al login, redirigir a la página principal
    router.navigate(['/admin/dashboard']);
    return false;
  }

  if (isAuthenticated.id === '0') {
    // Si el usuario no está autenticado, redirigir al login
    router.navigate(['/auth/sign-in']);
    return false;
  }

  // Si el usuario está autenticado y no trata de ir al login, permitir la navegación
  return true;
};
